<template>
  <div id="NewsPage" v-wechat-title="pageTitle">
    <no-data v-if="isNoData" class="no-data-box" />

    <div v-else>
      <div
        class="news-box"
        v-for="item in newsList"
        :key="item.noticeId"
        @click="toNewsDetail(item)"
      >
        <!-- 有图片 -->
        <img
          v-if="item.noticeCover"
          class="news-left"
          :src="baseUrl + item.noticeCover"
          alt="avatar"
        />
        <!-- 无图片 -->
        <template v-else>
          <img class="news-left" :src="defaultImg" alt="" />
          <div class="bg-text">{{ pageTitle }}</div>
        </template>
        <!-- 标题 -->
        <ul class="news-right">
          <li>{{ item.noticeTitle }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import serverconfig from '@/api/server.config';
let HALL_WECHAT_API = serverconfig.API;

import NoData from '@/components/noData';
import { selectNoticeList, selectNoticeDetail, calcReadNum } from '@/api/user';
export default {
  name: 'NewsList',
  components: {
    NoData
  },
  data() {
    return {
      // newsList,
      newsList: [],
      refreshing: false,
      finished: false,
      finishedText: '',
      loading: false,
      currentPage: 1,
      pageSize: 10,
      dataTotal: 0,
      noticeType: this.$route.query.noticeType || 'orgnews',
      pageTitle: this.$route.query.pageTitle,
      defaultImg: require('../NoticePage/NewsList//bg.png'),
      baseUrl: HALL_WECHAT_API + '/biz/file/view?fileId=',
      isNoData: false
    };
  },
  mounted() {
    this.getNotice();
  },
  methods: {
    // dayjs,
    async getNotice() {
      // this.newsList = [{"noticeId":"1921761882846859265","noticeType":"waterquality","noticeTitle":"2025年第一季度王家山水厂水质检测报告","releaseTime":"2025-05-12 10:55:18","startTime":"2025-05-12 00:00:00","endTime":"2099-12-31 23:59:59","waterCutArea":null,"noticeCover":null,"noticeDescribe":"<p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761719978332161\"/></p><p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761760910544898\"/></p><p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761788358070274\"/></p><p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761819572080641\"/></p><p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761842116464641\"/></p><p><br/></p>","noticeForm":"0","pageViews":0,"isRelease":true,"tenantId":"1866028748747345922","createBy":"刘黎亮","createTime":"2025-05-12 10:58:32","updateBy":"rcAdmin","updateTime":"2025-07-14 10:41:23","readNum":29,"likeNum":0,"sumReadNum":null,"noticeTypeName":"水质公告"}]
      // let params = {
      //     noticeType: this.noticeType,
      // }
      let params = {
        page: { current: 1, size: 9999 },
        noticeType: this.noticeType
      };
      const { status, resultData } = await selectNoticeList(params);
      if (status === 'complete') {
        if (resultData.count === 0) {
          this.isNoData = true;
        } else {
          this.newsList = resultData.entities;
        }
      }
    },
    async toNewsDetail(newsItem) {
      let res = await calcReadNum(newsItem.noticeId);
      console.log(res, '阅读计数');
      const { resultData } = await selectNoticeDetail(newsItem.noticeId);
      if (resultData.noticeForm === '1') {
        window.open(resultData.noticeDescribe, '_blank');
      } else {
        this.$router.push({
          path: '/NewsNotice/NewsDetail',
          query: {
            noticeId: newsItem.noticeId,
            pageTitle: this.pageTitle + '详情'
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
#NewsPage {
  padding: 16px;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  font-size: 14px;
  color: #333;
  background-color: #f7f7f7;

  .news-box {
    position: relative;
    margin-top: 12px;
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    background: #fff;
    box-shadow: 0 -2px 12px -10px rgba(53, 59, 68, 0.3);
    border-radius: 4px;

    &:first-child {
      margin-top: 0px;
    }

    .bg-text {
      color: rgb(255, 255, 255);
      font-weight: bold;
      position: absolute;
      line-height: 47px;
      width: 76px;
      text-align: center;
      letter-spacing: 1px;
      font-family: 黑体;
    }

    .news-left {
      width: 76px;
      height: 47px;
      border-radius: 4px;
    }

    .news-right {
      padding-left: 20px;
      width: calc(100% - 110px);
      display: flex;
      flex: 1;
      flex-direction: column;

      li:first-child {
        font-size: 16px;
        font-weight: 500;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      li:last-child {
        padding-top: 8px;
        color: #666;
      }
    }
  }

  .no-data-box {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    height: 100vh;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 2px 2px 4px 0 rgba(213, 218, 225, 0.3);
    background-color: #fff;

    div:first-child {
      font-size: 16px;
      font-weight: 700;
      text-align: center;
    }

    /deep/ .noData {
      margin-top: 3% !important;
    }
  }
}
</style>
